import { FacebookEmbed } from "react-social-media-embed";
import { facebookPosts, instagramPosts } from "../../somePosts";
import FacebookButton from "../../Components/FacebookButton";
import InstagramButton from "../../Components/InstagramButton";
import "./MobileFrontpage.css";
import { useState } from "react";
import MobileHolidayGreeter from "../MobileComponents/MobileHolidayGreeter";
import ChristmasLights from "../../Components/ChristmasLights";

export default function MobileHome() {
  const [facebookActive, setFacebookActive] = useState(false);
  const [instagramActive, setInstagramActive] = useState(false);

  function activateFacebook() {
    setInstagramActive(false);
    setFacebookActive(true);
    if (facebookActive === true) {
      setFacebookActive(false);
    }
  }
  function activateInstagram() {
    setFacebookActive(false);
    setInstagramActive(true);
    if (instagramActive === true) {
      setInstagramActive(false);
    }
  }

  const date = new Date().toDateString().split(" ");

  return (
    <div className="mobile-frontpage">
      <div className="mobile-some-buttongroup">
        <button className="mobile-some-button" onClick={activateFacebook}>
          Facebook
        </button>
        <button className="mobile-some-button" onClick={activateInstagram}>
          Instagram
        </button>
      </div>
      <div style={{ marginTop: "-7%" }}>
        {date[1] === "Dec" ? <ChristmasLights /> : ""}
      </div>
      {facebookActive === true && instagramActive === false ? (
        <div className="mobile-facebook">
          <FacebookEmbed
            className="mobile-facebook-bg"
            url={facebookPosts[0]}
            width={340}
          />
          <div style={{ backgroundColor: "black", padding: "1%" }}>
            <FacebookButton />
          </div>
          <MobileHolidayGreeter />
        </div>
      ) : (
        ""
      )}

      {facebookActive === false && instagramActive === true ? (
        <div className="mobile-instagram">
          {/* <InstagramEmbed url={instagramPosts[0]} width={340} /> */}
          <iframe
            title="Instagram post"
            src={`${instagramPosts[0]}embed/`}
            frameBorder="0"
            scrolling="no"
            allowTransparency="true"
            allow="encrypted-media"
            style={{
              border: "none",
              overflow: "hidden",
              width: "100%",
              height: "80vh",
              maxHeight: "600px",
              marginRight: "5%"
            }}
          /><div style={{ backgroundColor: "black", padding: "1%" }}>
            <InstagramButton />
          </div>
          <MobileHolidayGreeter />
        </div>
      ) : (
        ""
      )}
      {!facebookActive && !instagramActive && (
        <MobileHolidayGreeter className="standalone" />
      )}
    </div>
  );
}
